// Copyright (c) Docugami, Inc. All rights reserved.
// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Frontend API
 * REST API for Frontend endpoints
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, RequestArgs, BaseAPI, RequiredError } from './base';
import { Config } from 'config';
import { Chunk } from 'store/dgml/dgmlTypes';
import { ProviderId } from './StorageProviders';

/**
 * @export
 * @interface ChunkSuggestion
 */
export interface ChunkSuggestion {
    /**
     *
     * @type {string}
     * @memberof ChunkSuggestion
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof ChunkSuggestion
     */
    label?: string;
    /**
     *
     * @type {string}
     * @memberof ChunkSuggestion
     */
    followingSiblingId?: string;
    /**
     *
     * @type {string}
     * @memberof ChunkSuggestion
     */
    precedingSiblingId?: string;
    /**
     *
     * @type {number}
     * @memberof ChunkSuggestion
     */
    likelihood?: number;

    /**
     * @type {Array<Fragment>}
     * @memberof ChunkSuggestion
     */
    variants?: Array<Fragment>;
}
/**
 * @export
 * @interface Field
 */
export interface Field {
    id: string;
    label: string;
    likelihood: number;
    suggestedValues: Array<string>;
}
/**
 * @export
 * @interface AssistedAuthoringChunkInfo
 */
export interface AssistedAuthoringChunkInfo {
    /**
     *
     * @type {string}
     * @memberof AssistedAuthoringChunkInfo
     */
    spanId: string;
    /**
     *
     * @type {string}
     * @memberof AssistedAuthoringChunkInfo
     */
    folderId: string;
    /**
     *
     * @type {string}
     * @memberof AssistedAuthoringChunkInfo
     */
    containerHeader: string;
    /**
     *
     * @type {string}
     * @memberof AssistedAuthoringChunkInfo
     */
    suggestedLabel: string;
    /**
     *
     * @type {string}
     * @memberof AssistedAuthoringChunkInfo
     */
    suggestingMethod: string;
    /**
     *
     * @type {number}
     * @memberof AssistedAuthoringChunkInfo
     */
    likelihood: number;
    /**
     *
     * @type {number}
     * @memberof AssistedAuthoringChunkInfo
     */
    fragmentLikelihood: number;
    /**
     * @type {Array<Fragment>}
     * @memberof AssistedAuthoringChunkInfo
     */
    suggestedChunks: Array<ChunkSuggestion>;
    /**
     * @type {Array<Fragment>}
     * @memberof AssistedAuthoringChunkInfo
     */
    variants: Array<Fragment>;
    /**
     * @type {Array<Fragment>}
     * @memberof AssistedAuthoringChunkInfo
     */
    fields: Array<Field>;
}
/**
 *
 * @export
 * @enum BuildState
 */
export enum BuildState {
    NotStarted = 'NotStarted',
    InProgress = 'InProgress',
    Failed = 'Failed',
    Succeeded = 'Succeeded',
    Cancelled = 'Cancelled',
    Timeout = 'Timeout',
}

export enum DocumentStatus
{
    New = 'New',
    Ingesting = 'Ingesting',
    Ingested = 'Ingested',
    Processing = 'Processing',
    Ready = 'Ready',
    Error = 'Error',
    OverQuota = 'OverQuota'
}

/**
 *
 * @export
 * @interface ChunkInstance
 */
export interface ChunkInstance {
    /**
     *
     * @type {string}
     * @memberof ChunkInstance
     */
    chunkInstanceId?: string;
    /**
     *
     * @type {string}
     * @memberof AssistedAuthoringChunkInfo
     */
    spanId?: string;
    /**
     *
     * @type {string}
     * @memberof ChunkInstance
     */
    labelId?: string;
    /**
     *
     * @type {string}
     * @memberof ChunkInstance
     */
    folderId: string;
    /**
     *
     * @type {boolean}
     * @memberof ChunkInstance
     */
    hasAssistedAuthoringInfo?: boolean;
    /**
     *
     * @type {TokenRange}
     * @memberof ChunkInstance
     */
    tokenRange: TokenRange;

    isAddedChunk?: boolean;

    chunk?: Chunk; // Added on the client
}

export interface AddedChunkInfo {
    value: string;
    propertyId?: string | null;
}

/**
 *
 * @export
 * @enum IngestionIssues
 */
export enum IngestionIssues {
    NoIssues = 0,
    FileTypeNotSupported = 1 << 0,
    InvalidPdf = 1 << 1,
    EncryptedPdf = 1 << 2,
    PdfUnknownError = 1 << 3,
    DocxUnknownError = 1 << 4,
    FileSizeExceeded = 1 << 5,
    PageCountExceeded = 1 << 6,
    Encrypted = 1 << 7,
    VisionLayoutError = 1 << 8,
    VisionTableError = 1 << 9,
    StartFilesError = 1 << 10,
    WordStartError = 1 << 11,
    Pdf2ImagesError = 1 << 12,
    OCRError = 1 << 13,
    AggregationError = 1 << 14,
    ReadingOrderError = 1 << 15,
    DocumentReadingOrderError = 1 << 16,
    LinedTableError = 1 << 17,
    WordyError = 1 << 18,
    PostFlightValidationError = 1 << 19,
    ProcessImageError = 1 << 20,
    PrecheckError = 1 << 21,
    DigitalTextExtractionError = 1 << 22,
    FileSizeZero = 1 << 23,
    InferenceRequestError = 1 << 24,
    EmptyStartText = 1 << 25
}
/**
 *
 * @export
 * @enum IngestionStatus
 */
export enum IngestionStatus {
    NotStarted = 0,
    Started = 1,
    Failed = 2,
    Succeeded = 3,
    Dropped = 4
}
/**
 *
 * @export
 * @enum IngestionWarnings
 */
export enum IngestionWarnings {
    NoIssues = 0,
    PageLimitExceeded = 1 << 0,
    ChallengingLayout = 1 << 1,
}
/**
 *
 * @export
 * @interface ClusterDocument
 */
export interface ClusterDocument {
    /**
     *
     * @type {string}
     * @memberof ClusterDocument
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof ClusterDocument
     */
    clusterId: string;
    /**
     *
     * @type {string}
     * @memberof ClusterDocument
     */
    filename: string;
    /**
     *
     * @type {string}
     * @memberof ClusterDocument
     */
    fileId: string;
    /**
     *
     * @type {boolean}
     * @memberof ClusterDocument
     */
    hasCpml?: boolean;
    /**
     *
     * @type {string}
     * @memberof ClusterDocument
     */
    folderId: string;

    displayName?: string;
    numberOfPages: number;
    ingestionStatus?: IngestionStatus
    ingestionWarnings?: IngestionWarnings
    ingestionIssues?: IngestionIssues
    sizeBytes?: number
    metadataId: string;
    createdAt?: Date;
    status: DocumentStatus;

    remoteStorageMetadata?: RemoteStorageMetadata;
}
export interface RemoteStorageMetadata {
    providerId: ProviderId;
    itemId: string;
    metadata: string;
}

/**
 *
 * @export
 * @interface ClusterInfo
 */
export interface ClusterInfo {
    /**
     *
     * @type {string}
     * @memberof ClusterInfo
     */
    documentType?: string;
    /**
     *
     * @type {string}
     * @memberof ClusterInfo
     */
    self?: string;
    /**
     *
     * @type {string}
     * @memberof ClusterInfo
     */
    rid?: string;
    /**
     *
     * @type {string}
     * @memberof ClusterInfo
     */
    clusterId?: string;
    /**
     *
     * @type {string}
     * @memberof ClusterInfo
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof ClusterInfo
     */
    label?: string;
    /**
     *
     * @type {number}
     * @memberof ClusterInfo
     */
    numberOfDocuments: number;

    isDocugamiCluster?: boolean;

    buildStatus?: { [buildType: string]: BuildState };

    sampleCatalogItemId?: string;
}
/**
 *
 * @export
 * @interface Code
 */
export interface Code {
    /**
     *
     * @type {number}
     * @memberof Code
     */
    confidence: number;
    /**
     *
     * @type {string}
     * @memberof Code
     */
    value?: string;
}
/**
 *
 * @export
 * @interface CpmlChangeOperation
 */
export interface CpmlChangeOperation {
    /**
     *
     * @type {string}
     * @memberof CpmlChangeOperation
     */
    operationType?: string;
    /**
     *
     * @type {string}
     * @memberof CpmlChangeOperation
     */
    extraInfo?: string;
}
/**
 *
 * @export
 * @interface CpmlUserAction
 */
export interface CpmlUserAction {
    /**
     *
     * @type {Array<CpmlChangeOperation>}
     * @memberof CpmlUserAction
     */
    operations?: Array<CpmlChangeOperation>;
    /**
     *
     * @type {string}
     * @memberof CpmlUserAction
     */
    sourceNodeXPath?: string;
    /**
     *
     * @type {string}
     * @memberof CpmlUserAction
     */
    targetNodeXPath?: string;
}
/**
 *
 * @export
 * @interface FileInfo
 */
export interface FileInfo {
    /**
     *
     * @type {string}
     * @memberof FileInfo
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof FileInfo
     */
    clusterId?: string;
    /**
     *
     * @type {string}
     * @memberof FileInfo
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof FileInfo
     */
    displayName?: string;
    /**
     *
     * @type {boolean}
     * @memberof FileInfo
     */
    hasCpml: boolean;
    /**
     *
     * @type {IngestionIssues}
     * @memberof FileInfo
     */
    ingestionIssues?: IngestionIssues;
    /**
     *
     * @type {IngestionStatus}
     * @memberof FileInfo
     */
    ingestionStatus?: IngestionStatus;
    /**
     *
     * @type {IngestionWarnings}
     * @memberof FileInfo
     */
    ingestionWarnings?: IngestionWarnings;
    /**
     *
     * @type {number}
     * @memberof FileInfo
     */
    sizeBytes: number;
    /**
     *
     * @type {number}
     * @memberof FileInfo
     */
    sizeKiloBytes: number;
    /**
     *
     * @type {Date}
     * @memberof FileInfo
     */
    createdAt?: Date;
    /**
     *
     * @type {DocumentStatus}
     * @memberof FileInfo
     */
    status: DocumentStatus;
}
/**
 *
 * @export
 * @interface Fragment
 */
export interface Fragment {
    /**
     *
     * @type {string}
     * @memberof Fragment
     */
    fragmentId?: string;
    /**
     *
     * @type {string}
     * @memberof Fragment
     */
    folderId?: string;
    /**
     *
     * @type {string}
     * @memberof Fragment
     */
    chunkInstanceId?: string;
    /**
     *
     * @type {string}
     * @memberof Fragment
     */
    rawText?: string;
    /**
     *
     * @type {string}
     * @memberof Fragment
     */
    dgml?: string;
    /**
     *
     * @type {string[]}
     * @memberof Fragment
     */
    fieldSpanIds?: string[];
    /**
     *
     * @type {string}
     * @memberof Fragment
     */
    xmlFragment?: string;
    /**
     *
     * @type {number}
     * @memberof Fragment
     */
    hitCount: number;
    /**
     *
     * @type {number}
     * @memberof Fragment
     */
    likelihood: number;
    /**
     *
     * @type {string}
     * @memberof Fragment
     */
    referencingLabel?: string;
}
/**
 *
 * @export
 * @interface IHeaderDictionary
 */
export interface IHeaderDictionary {
    /**
     *
     * @type {Array<string>}
     * @memberof IHeaderDictionary
     */
    item: Array<string>;
    /**
     *
     * @type {number}
     * @memberof IHeaderDictionary
     */
    contentLength?: number;
}
/**
 *
 * @export
 * @interface ModelBase
 */
export interface ModelBase {
    /**
     *
     * @type {string}
     * @memberof ModelBase
     */
    documentType?: string;
    /**
     *
     * @type {string}
     * @memberof ModelBase
     */
    self?: string;
    /**
     *
     * @type {string}
     * @memberof ModelBase
     */
    rid?: string;
}
/**
 *
 * @export
 * @interface PageInfo
 */
export interface PageInfo {
    /**
     *
     * @type {number}
     * @memberof PageInfo
     */
    number: number;
    /**
     *
     * @type {string}
     * @memberof PageInfo
     */
    image?: string;
    /**
     *
     * @type {string}
     * @memberof PageInfo
     */
    tokensInfo?: string;
    /**
     *
     * @type {number}
     * @memberof PageInfo
     */
    height: number;
    /**
     *
     * @type {number}
     * @memberof PageInfo
     */
    width: number;
    /**
     *
     * @type {number}
     * @memberof PageInfo
     */
    fromTok?: number;
    /**
     *
     * @type {number}
     * @memberof PageInfo
     */
    toTok?: number;
    /**
     *
     * @type {TokenRange[]}
     * @memberof PageInfo
     */
    tokenRanges: TokenRange[];
}
/**
 *
 * @export
 * @interface TokenRange
 */
export interface TokenRange {
    /**
     *
     * @type {number}
     * @memberof TokenRange
     */
    fromTok: number;
    /**
     *
     * @type {number}
     * @memberof TokenRange
     */
    toTok: number;
}

/**
 * ClientConfigurationApi - axios parameter creator
 * @export
 */
export const ClientConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
        *
        * @param {*} [options] Override http request option.
        * @throws {RequiredError}
        */
        clientConfigurationConnectionString(options: any = {}): RequestArgs {
            const localVarPath = `/ClientConfiguration/ConnectionString`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }
    }
};

/**
 * ClientConfigurationApi - functional programming interface
 * @export
 */
export const ClientConfigurationApiFp = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientConfigurationConnectionString(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ClientConfigurationApiAxiosParamCreator(configuration).clientConfigurationConnectionString(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientConfigurationApi - factory interface
 * @export
 */
export const ClientConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientConfigurationConnectionString(options?: any) {
            return ClientConfigurationApiFp(configuration).clientConfigurationConnectionString(options)(axios, basePath);
        },
    };
};

/**
 * ClientConfigurationApi - object-oriented interface
 * @export
 * @class ClientConfigurationApi
 * @extends {BaseAPI}
 */
export class ClientConfigurationApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientConfigurationApi
     */
    public clientConfigurationConnectionString(options?: any) {
        return ClientConfigurationApiFp(this.configuration).clientConfigurationConnectionString(options)(this.axios, this.basePath);
    }
}


/**
 * ClusterApi - axios parameter creator
 * @export
 */
export const ClusterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterGetClusters(options: any = {}): RequestArgs {
            const localVarPath = `/Cluster`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ClusterInfo} clusterInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterUpdateCluster(clusterInfo: ClusterInfo, options: any = {}): RequestArgs {
            // verify required parameter 'clusterInfo' is not null or undefined
            if (clusterInfo === null || clusterInfo === undefined) {
                throw new RequiredError('clusterInfo', 'Required parameter clusterInfo was null or undefined when calling clusterUpdateCluster.');
            }
            const localVarPath = `/Cluster`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            localVarRequestOptions.data = JSON.stringify(clusterInfo !== undefined ? clusterInfo : {});

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} clusterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterGetCluster(clusterId: string, options: any = {}): RequestArgs {
            if (clusterId === null || clusterId === undefined) {
                throw new RequiredError('clusterId', 'Required parameter clusterId was null or undefined when calling clusterGetCluster.');
            }
            const localVarPath = `/Cluster/{clusterId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} clusterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterDeleteCluster(clusterId: string, options: any = {}): RequestArgs {
            if (clusterId === null || clusterId === undefined) {
                throw new RequiredError('clusterId', 'Required parameter clusterId was null or undefined when calling clusterDeleteCluster.');
            }
            const localVarPath = `/Cluster/{clusterId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterCreateCluster(label: string, options: any = {}): RequestArgs {
            if (label === null || label === undefined) {
                throw new RequiredError('label', 'Required parameter clusterId was null or undefined when calling clusterCreateCluster.');
            }
            const localVarPath = `/Cluster/create/{label}`
                .replace(`{${"label"}}`, encodeURIComponent(String(label)))
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        clusterRenameCluster(clusterId: string, label: string, options: any = {}): RequestArgs {
            if (!label) {
                throw new RequiredError('label', 'Required parameter label was null or undefined when calling renameCluster.');
            }

            if (!clusterId) {
                throw new RequiredError('clusterId', 'Required parameter clusterId was null or undefined when calling renameCluster.');
            }

            const localVarPath = `/Cluster/${encodeURIComponent(clusterId)}/rename/${encodeURIComponent(label)}`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }
    }
};

/**
 * ClusterApi - functional programming interface
 * @export
 */
export const ClusterApiFp = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterGetClusters(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClusterInfo>> {
            const localVarAxiosArgs = ClusterApiAxiosParamCreator(configuration).clusterGetClusters(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {ClusterInfo} clusterInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterUpdateCluster(clusterInfo: ClusterInfo, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = ClusterApiAxiosParamCreator(configuration).clusterUpdateCluster(clusterInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} clusterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterGetCluster(clusterId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterInfo> {
            const localVarAxiosArgs = ClusterApiAxiosParamCreator(configuration).clusterGetCluster(clusterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} clusterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterDeleteCluster(clusterId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = ClusterApiAxiosParamCreator(configuration).clusterDeleteCluster(clusterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterCreateCluster(label: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterInfo> {
            const localVarAxiosArgs = ClusterApiAxiosParamCreator(configuration).clusterCreateCluster(label, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },

        clusterRenameCluster(clusterId: string, label: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ClusterApiAxiosParamCreator(configuration).clusterRenameCluster(clusterId, label, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        }
    }
};

/**
 * ClusterApi - factory interface
 * @export
 */
export const ClusterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterGetClusters(options?: any) {
            return ClusterApiFp(configuration).clusterGetClusters(options)(axios, basePath);
        },
        /**
         *
         * @param {ClusterInfo} clusterInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterUpdateCluster(clusterInfo: ClusterInfo, options?: any) {
            return ClusterApiFp(configuration).clusterUpdateCluster(clusterInfo, options)(axios, basePath);
        },
        /**
         *
         * @param {string} clusterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterGetCluster(clusterId: string, options?: any) {
            return ClusterApiFp(configuration).clusterGetCluster(clusterId, options)(axios, basePath);
        },
        /**
         *
         * @param {string} clusterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterDeleteCluster(clusterId: string, options?: any) {
            return ClusterApiFp(configuration).clusterDeleteCluster(clusterId, options)(axios, basePath);
        },
        /**
         *
         * @param {string} label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterCreateCluster(label: string, options?: any) {
            return ClusterApiFp(configuration).clusterCreateCluster(label, options)(axios, basePath);
        },

        clusterRenameCluster(clusterId: string, label: string, options?: any) {
            return ClusterApiFp(configuration).clusterRenameCluster(clusterId, label, options)(axios, basePath);
        }
    };
};

/**
 * ClusterApi - object-oriented interface
 * @export
 * @class ClusterApi
 * @extends {BaseAPI}
 */
export class ClusterApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    public clusterGetClusters(options?: any) {
        return ClusterApiFp(this.configuration).clusterGetClusters(options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {ClusterInfo} clusterInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    public clusterUpdateCluster(clusterInfo: ClusterInfo, options?: any) {
        return ClusterApiFp(this.configuration).clusterUpdateCluster(clusterInfo, options)(this.axios, this.basePath);
    }

    /**
    *
    * @param {string} clusterId
    * @param {*} [options] Override http request option.
    * @throws {RequiredError}
    * @memberof ClusterApi
    */
    public clusterGetCluster(clusterId: string, options?: any) {
        return ClusterApiFp(this.configuration).clusterGetCluster(clusterId, options)(this.axios, this.basePath);
    }

    /**
    *
    * @param {string} clusterId
    * @param {*} [options] Override http request option.
    * @throws {RequiredError}
    * @memberof ClusterApi
    */
    public clusterDeleteCluster(clusterId: string, options?: any) {
        return ClusterApiFp(this.configuration).clusterDeleteCluster(clusterId, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string} label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClusterApi
     */
    public clusterCreateCluster(label: string, options?: any) {
        return ClusterApiFp(this.configuration).clusterCreateCluster(label, options)(this.axios, this.basePath);
    }

    public clusterRenameCluster(clusterId: string, label: string, options?: any) {
        return ClusterApiFp(this.configuration).clusterRenameCluster(clusterId, label, options)(this.axios, this.basePath);
    }
}


/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadAllFiles(folderId: string, options: any = {}, includeAll: boolean = false): RequestArgs {
            // verify required parameter 'folderId' is not null or undefined
            if (folderId === null || folderId === undefined) {
                throw new RequiredError('folderId', 'Required parameter folderId was null or undefined when calling documentDownloadAllFiles.');
            }
            const localVarPath = `/documents/{folderId}/downloadfiles`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = { includeAll } as any;



            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} folderId
         * @param {string} pageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadPageImage(folderId: string, pageId: string, options: any = {}): RequestArgs {
            // verify required parameter 'folderId' is not null or undefined
            if (folderId === null || folderId === undefined) {
                throw new RequiredError('folderId', 'Required parameter folderId was null or undefined when calling documentDownloadPageImage.');
            }
            // verify required parameter 'pageId' is not null or undefined
            if (pageId === null || pageId === undefined) {
                throw new RequiredError('pageId', 'Required parameter pageId was null or undefined when calling documentDownloadPageImage.');
            }
            const localVarPath = `/documents/{folderId}/page/{pageId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)))
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} folderId
         * @param {string} tokenMapId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadTokensForPage(folderId: string, tokenMapId: string, options: any = {}): RequestArgs {
            // verify required parameter 'folderId' is not null or undefined
            if (folderId === null || folderId === undefined) {
                throw new RequiredError('folderId', 'Required parameter folderId was null or undefined when calling documentDownloadTokensForPage.');
            }
            // verify required parameter 'tokenMapId' is not null or undefined
            if (tokenMapId === null || tokenMapId === undefined) {
                throw new RequiredError('tokenMapId', 'Required parameter tokenMapId was null or undefined when calling documentDownloadTokensForPage.');
            }
            const localVarPath = `/documents/{folderId}/tokenMapping/{tokenMapId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)))
                .replace(`{${"tokenMapId"}}`, encodeURIComponent(String(tokenMapId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocument(filename: string, options: any = {}): RequestArgs {
            // verify required parameter 'filename' is not null or undefined
            if (filename === null || filename === undefined) {
                throw new RequiredError('filename', 'Required parameter filename was null or undefined when calling documentGetDocument.');
            }
            const localVarPath = `/documents/{filename}`
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string[]} folderIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocumentsFromFolderIds(folderIds: string[], options: any = {}): RequestArgs {
            // verify required parameter 'folderId' is not null or undefined
            if (folderIds === null || folderIds === undefined) {
                throw new RequiredError('folderIds', 'Required parameter folderIds was null or undefined when calling documentGetDocumentsFromFolderIds.');
            }
            const localVarPath = `/documents/document`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            localVarRequestOptions.data = JSON.stringify(folderIds);

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} clusterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocuments(clusterId: string, options: any = {}): RequestArgs {
            // verify required parameter 'clusterId' is not null or undefined
            if (clusterId === null || clusterId === undefined) {
                throw new RequiredError('clusterId', 'Required parameter clusterId was null or undefined when calling documentGetDocuments.');
            }
            const localVarPath = `/clusters/{clusterId}/documents`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetPagesForDocument(folderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'folderId' is not null or undefined
            if (folderId === null || folderId === undefined) {
                throw new RequiredError('folderId', 'Required parameter folderId was null or undefined when calling documentGetPagesForDocument.');
            }
            const localVarPath = `/documents/{folderId}/page_info`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadAllFiles(folderId: string, options?: any, includeAll: boolean = false): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).documentDownloadAllFiles(folderId, options, includeAll);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} folderId
         * @param {string} pageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadPageImage(folderId: string, pageId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).documentDownloadPageImage(folderId, pageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} folderId
         * @param {string} tokenMapId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadTokensForPage(folderId: string, tokenMapId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).documentDownloadTokensForPage(folderId, tokenMapId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocument(filename: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterDocument> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).documentGetDocument(filename, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string[]} folderIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocumentsFromFolderIds(folderIds: string[], options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterDocument[]> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).documentGetDocumentsFromFolderIds(folderIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} clusterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocuments(clusterId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClusterDocument>> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).documentGetDocuments(clusterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetPagesForDocument(folderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageInfo>> {
            const localVarAxiosArgs = DocumentApiAxiosParamCreator(configuration).documentGetPagesForDocument(folderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadAllFiles(folderId: string, options?: any, includeAll: boolean = false) {
            return DocumentApiFp(configuration).documentDownloadAllFiles(folderId, options, includeAll)(axios, basePath);
        },
        /**
         *
         * @param {string} folderId
         * @param {string} pageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadPageImage(folderId: string, pageId: string, options?: any) {
            return DocumentApiFp(configuration).documentDownloadPageImage(folderId, pageId, options)(axios, basePath);
        },
        /**
         *
         * @param {string} folderId
         * @param {string} tokenMapId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentDownloadTokensForPage(folderId: string, tokenMapId: string, options?: any) {
            return DocumentApiFp(configuration).documentDownloadTokensForPage(folderId, tokenMapId, options)(axios, basePath);
        },
        /**
         *
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocument(filename: string, options?: any) {
            return DocumentApiFp(configuration).documentGetDocument(filename, options)(axios, basePath);
        },
        /**
         *
         * @param {string[]} folderIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocumentsFromFolderIds(folderIds: string[], options?: any) {
            return DocumentApiFp(configuration).documentGetDocumentsFromFolderIds(folderIds, options)(axios, basePath);
        },
        /**
         *
         * @param {string} clusterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetDocuments(clusterId: string, options?: any) {
            return DocumentApiFp(configuration).documentGetDocuments(clusterId, options)(axios, basePath);
        },
        /**
         *
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentGetPagesForDocument(folderId: string, options?: any) {
            return DocumentApiFp(configuration).documentGetPagesForDocument(folderId, options)(axios, basePath);
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     *
     * @param {string} folderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentDownloadAllFiles(folderId: string, options?: any, includeAll: boolean = false) {
        return DocumentApiFp(this.configuration).documentDownloadAllFiles(folderId, options, includeAll)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string} folderId
     * @param {string} pageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentDownloadPageImage(folderId: string, pageId: string, options?: any) {
        return DocumentApiFp(this.configuration).documentDownloadPageImage(folderId, pageId, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string} folderId
     * @param {string} tokenMapId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentDownloadTokensForPage(folderId: string, tokenMapId: string, options?: any) {
        return DocumentApiFp(this.configuration).documentDownloadTokensForPage(folderId, tokenMapId, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentGetDocument(filename: string, options?: any) {
        return DocumentApiFp(this.configuration).documentGetDocument(filename, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string[]} folderIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentGetDocumentsFromFolderIds(folderIds: string[], options?: any) {
        return DocumentApiFp(this.configuration).documentGetDocumentsFromFolderIds(folderIds, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string} clusterId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentGetDocuments(clusterId: string, options?: any) {
        return DocumentApiFp(this.configuration).documentGetDocuments(clusterId, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string} folderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public documentGetPagesForDocument(folderId: string, options?: any) {
        return DocumentApiFp(this.configuration).documentGetPagesForDocument(folderId, options)(this.axios, this.basePath);
    }
}

/**
 * FileManagerDataApi - axios parameter creator
 * @export
 */
export const FileManagerDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} [path]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataDelete(path: string, options: any = {}): RequestArgs {
            const localVarPath = `/files/delete`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            localVarRequestOptions.data = JSON.stringify(path);

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [filepath]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataValidateFile(filepath: string, options: any = {}): RequestArgs {
            const localVarPath = `/files/validate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            localVarRequestOptions.data = JSON.stringify(filepath);

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [paths]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataGetFiles(paths: string[], options: any = {}): RequestArgs {
            const localVarPath = `/files`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            localVarRequestOptions.data = JSON.stringify(paths);

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} docSetId
         * @param {string[]} filepaths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataAssignFiles(docSetId: string, filepaths: string[], options: any = {}): RequestArgs {
            const localVarPath = `/docset/assign/{docSetId}`
                .replace(`{${"docSetId"}}`, encodeURIComponent(String(docSetId)))
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            localVarRequestOptions.data = JSON.stringify(filepaths);

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string[]} filepaths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataUnassignFiles(filepaths: string[], options: any = {}): RequestArgs {
            const localVarPath = `/docset/unassign`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            localVarRequestOptions.data = JSON.stringify(filepaths);

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataGetFileCount(path?: string, options: any = {}): RequestArgs {
            const localVarPath = '/files/count';
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
            localVarRequestOptions.data = JSON.stringify(path ?? '');

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        fileManagerDataGetErrorFiles(options: any = {}): RequestArgs {
            const localVarPath = '/files/error';
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        fileManagerGetStartText(folderId: string, version?: string, options: any = {}): RequestArgs {
            const localVarPath = `/files/${encodeURIComponent(folderId)}/start/${!!version ? encodeURIComponent(version) : ''}`
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }
    }
};

/**
 * FileManagerDataApi - functional programming interface
 * @export
 */
export const FileManagerDataApiFp = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} [path]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataDelete(path: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = FileManagerDataApiAxiosParamCreator(configuration).fileManagerDataDelete(path, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [filepath]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataValidateFile(filepath: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileValidationResult> {
            const localVarAxiosArgs = FileManagerDataApiAxiosParamCreator(configuration).fileManagerDataValidateFile(filepath, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string[]} [paths]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataGetFiles(paths: string[], options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileInfo>> {
            const localVarAxiosArgs = FileManagerDataApiAxiosParamCreator(configuration).fileManagerDataGetFiles(paths, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} docSetId
         * @param {string[]} filepaths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataAssignFiles(docSetId: string, filepaths: string[], options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string[]> {
            const localVarAxiosArgs = FileManagerDataApiAxiosParamCreator(configuration).fileManagerDataAssignFiles(docSetId, filepaths, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string[]} filepaths
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataUnassignFiles(filepaths: string[], options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string[]> {
            const localVarAxiosArgs = FileManagerDataApiAxiosParamCreator(configuration).fileManagerDataUnassignFiles(filepaths, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileManagerDataGetFileCount(path?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = FileManagerDataApiAxiosParamCreator(configuration).fileManagerDataGetFileCount(path, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        fileManagerDataGetErrorFiles(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileInfo>> {
            const localVarAxiosArgs = FileManagerDataApiAxiosParamCreator(configuration).fileManagerDataGetErrorFiles(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        fileManagerGetStartText(folderId: string, version?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = FileManagerDataApiAxiosParamCreator(configuration).fileManagerGetStartText(folderId, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        }
    }
};

/**
 * FileManagerDataApi - object-oriented interface
 * @export
 * @class FileManagerDataApi
 * @extends {BaseAPI}
 */
export class FileManagerDataApi extends BaseAPI {
    constructor() {
        const config: Configuration = {
            basePath: Config.fileManagerApiUrl.replace(/\/+$/, "")
        }

        super(config);
    }

    /**
     *
     * @param {string} [path]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerDataApi
     */
    public fileManagerDataDelete(path: string, options?: any) {
        return FileManagerDataApiFp(this.configuration).fileManagerDataDelete(path, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string} [filepath]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerDataApi
     */
    public fileManagerDataValidateFile(filepath: string, options?: any) {
        return FileManagerDataApiFp(this.configuration).fileManagerDataValidateFile(filepath, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string} [paths]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerDataApi
     */
    public fileManagerDataGetFiles(paths: string[], options?: any) {
        return FileManagerDataApiFp(this.configuration).fileManagerDataGetFiles(paths, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string} docSetId
     * @param {string[]} paths
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerDataApi
     */
    public fileManagerDataAssignFiles(docSetId: string, paths: string[], options?: any) {
        return FileManagerDataApiFp(this.configuration).fileManagerDataAssignFiles(docSetId, paths, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string[]} paths
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerDataApi
     */
    public fileManagerDataUnassignFiles(paths: string[], options?: any) {
        return FileManagerDataApiFp(this.configuration).fileManagerDataUnassignFiles(paths, options)(this.axios, this.basePath);
    }

    /**
     *
     * @param {string[]} paths
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerDataApi
     */
    public fileManagerDataGetFileCount(path?: string, options?: any) {
        return FileManagerDataApiFp(this.configuration).fileManagerDataGetFileCount(path, options)(this.axios, this.basePath);
    }

    public fileManagerDataGetErrorFiles(options?: any) {
        return FileManagerDataApiFp(this.configuration).fileManagerDataGetErrorFiles(options)(this.axios, this.basePath);
    }

    public fileManagerGetStartText(folderId: string, version?: string, options?: any) {
        return FileManagerDataApiFp(this.configuration).fileManagerGetStartText(folderId, version, options)(this.axios, this.basePath);
    }
}

export interface DownloadFileAARequest {
    folderId: string;
    addinGuid: string;
    version: string;
    storeType: string;
    store: string;
}

export enum FileValidationResult {
    UnsupportedFileType = 'UnsupportedFileType',
    InvalidFilePath = 'InvalidFilePath',
    Conflict = 'Conflict',
    Valid = 'Valid'
}

export const ErrorDocumentBadgeId = 'Error';
export interface DocumentBadgesResponse {
    docSetBadges: { [docSetId: string]: string[] } | null;
    errorDocBadges: string[] | null;
}

export interface DocumentBadgesChangeNotification {
    data: DocumentBadgesResponse;
    userEmail: string;
}

export interface OrganizationFeatures {
    docsetMinFiles: number;
    workspaceDefaultProjectTemplate: boolean,
    isInlineChatEnabled: boolean
}

export interface VersionedFolderIdInput {
    folderId: string;
    fileName: string;
    version?: string;
}

export interface DownloadFilesDgmlRequest {
    files: VersionedFolderIdInput[];
}

export interface FileChangedMessage {
    document: ClusterDocument;
}

export interface QualityControlWarningsChangedMessage {
    docsetId: string;
    fileId: string;
}

export interface ModelStatsUpdatedMessage {
    docsetId: string;
}

export interface LabelRepeatsChangedMessage {
    docsetId: string;
    labelId: string;
    repeats: boolean;
}

export interface LabelRemovedMessage {
    docsetId: string;
}

export interface ValidationError {
    errors: Record<string, string[]>
    status: 400
    title: string
}

export const isValidationError = (error: any): error is ValidationError => error?.status === 400 && !!error?.title && !!error?.errors;
